





















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AlpacaBtn extends Vue {
  @Prop({
    type: String,
    required: false,
    default: 'normal',
  })
  public size!: 'normal' | 'large' | 'small';

  @Prop({
    type: Boolean,
    required: false,
    default: false,
  })
  public isLoading!: boolean;

  @Prop({
    type: Boolean,
    required: false,
    default: false,
  })
  public disabled!: boolean;

  @Prop({
    type: Boolean,
    required: false,
    default: true,
  })
  public hasCircle!: boolean;

  get shadowTransfer() {
    if (this.size === 'large') {
      return '8px';
    }
    return '4px';
  }

  public clickEvent() {
    if (this.isLoading) {
      return;
    }
    if (this.disabled) {
      return;
    }
    this.$emit('click');
  }
}
